import React from 'react';
import { KycModal } from '../../../modules/tt-modals';

const KycModalWrapper = ({ isOpen, setIsOpen, userId, userKyc }) => (
  <KycModal isOpen={isOpen} setIsOpen={setIsOpen} userId={userId} userKyc={userKyc} />
);

export default KycModalWrapper;
